module.exports = __webpack_public_path__ + "media/images/icons/download-e94d2f9d5b5e2ee4465287fbfdaacbb4.svg";